var map = {
	"./404.svg": "./src/icons/svg/404.svg",
	"./bug.svg": "./src/icons/svg/bug.svg",
	"./chart.svg": "./src/icons/svg/chart.svg",
	"./clipboard.svg": "./src/icons/svg/clipboard.svg",
	"./component.svg": "./src/icons/svg/component.svg",
	"./dashboard.svg": "./src/icons/svg/dashboard.svg",
	"./documentation.svg": "./src/icons/svg/documentation.svg",
	"./drag.svg": "./src/icons/svg/drag.svg",
	"./edit.svg": "./src/icons/svg/edit.svg",
	"./education.svg": "./src/icons/svg/education.svg",
	"./email.svg": "./src/icons/svg/email.svg",
	"./example.svg": "./src/icons/svg/example.svg",
	"./excel.svg": "./src/icons/svg/excel.svg",
	"./exit-fullscreen.svg": "./src/icons/svg/exit-fullscreen.svg",
	"./eye-open.svg": "./src/icons/svg/eye-open.svg",
	"./eye.svg": "./src/icons/svg/eye.svg",
	"./form.svg": "./src/icons/svg/form.svg",
	"./fullscreen.svg": "./src/icons/svg/fullscreen.svg",
	"./guide.svg": "./src/icons/svg/guide.svg",
	"./ic_facebook.svg": "./src/icons/svg/ic_facebook.svg",
	"./ic_footerlogo.svg": "./src/icons/svg/ic_footerlogo.svg",
	"./ic_ig.svg": "./src/icons/svg/ic_ig.svg",
	"./ic_line.svg": "./src/icons/svg/ic_line.svg",
	"./ic_youtube.svg": "./src/icons/svg/ic_youtube.svg",
	"./icon.svg": "./src/icons/svg/icon.svg",
	"./international.svg": "./src/icons/svg/international.svg",
	"./language.svg": "./src/icons/svg/language.svg",
	"./link.svg": "./src/icons/svg/link.svg",
	"./list.svg": "./src/icons/svg/list.svg",
	"./lock.svg": "./src/icons/svg/lock.svg",
	"./message.svg": "./src/icons/svg/message.svg",
	"./money.svg": "./src/icons/svg/money.svg",
	"./nested.svg": "./src/icons/svg/nested.svg",
	"./password.svg": "./src/icons/svg/password.svg",
	"./pdf.svg": "./src/icons/svg/pdf.svg",
	"./people.svg": "./src/icons/svg/people.svg",
	"./peoples.svg": "./src/icons/svg/peoples.svg",
	"./qq.svg": "./src/icons/svg/qq.svg",
	"./search.svg": "./src/icons/svg/search.svg",
	"./shopping.svg": "./src/icons/svg/shopping.svg",
	"./size.svg": "./src/icons/svg/size.svg",
	"./skill.svg": "./src/icons/svg/skill.svg",
	"./soical_Icon.svg": "./src/icons/svg/soical_Icon.svg",
	"./star.svg": "./src/icons/svg/star.svg",
	"./tab.svg": "./src/icons/svg/tab.svg",
	"./table.svg": "./src/icons/svg/table.svg",
	"./theme.svg": "./src/icons/svg/theme.svg",
	"./tree-table.svg": "./src/icons/svg/tree-table.svg",
	"./tree.svg": "./src/icons/svg/tree.svg",
	"./user.svg": "./src/icons/svg/user.svg",
	"./wechat.svg": "./src/icons/svg/wechat.svg",
	"./zip.svg": "./src/icons/svg/zip.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/icons/svg sync \\.svg$";